
(function metadataControllerDefinition() {
    'use strict';

    angular.module('Metadata')
        .controller('MetadataModifyController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', '$stateParams', 'adminMetadataService', 'authExtend', '$filter',
            function metadataController($scope, config, $state, $translate, errors, $stateParams, adminMetadataService, authExtend, $filter) {
                $scope.title = 'MetadataModify';
                $scope.metadata = {
                    id: 0,
                    hasAssociatedDocument: false
                };

                $scope.aux =
                    {
                        typeData: '',
                        MaskOption: undefined,
                        selected: {}
                    };

                $scope.requiredOu = authExtend.getOrganizationId() ? true : false;

                adminMetadataService.getTypeDatas().then(function (result) {
                    $scope.typeDatas = result;

                    adminMetadataService.getById($stateParams.id).then(function (metadataResult) {
                        $scope.metadata = metadataResult;
                        $scope.isOptionType = false;

                        if ($scope.metadata.attributes) {
                            for (var i = 0; $scope.metadata.attributes.length > i; i++) {
                                if ($scope.metadata.attributes[i].type === 'optionsValues') {
                                    $scope.isOptionType = true;
                                    $scope.metadata.attributes[i].values = $.parseJSON($scope.metadata.attributes[i].value);
                                    if (!$scope.metadata.attributes[i].values || $scope.metadata.attributes[i].values === '') {
                                        $scope.metadata.attributes[i].values = [];
                                    }

                                    $scope.metadata.attributes[i].values.forEach(function (data) {
                                        if (data.active === undefined) {
                                            data.active = true;
                                        }
                                    });
                                }
                            }
                        }

                        $scope.typeDatas.forEach(function (data) {
                            if (data.id === $scope.metadata.typeDataId) {
                                $scope.aux.typeData = data;
                            }
                        });

                        if ($scope.aux.typeData && $scope.aux.typeData.maskOptions) {

                            var r = $filter('filter')($scope.aux.typeData.maskOptions, { id: $scope.metadata.maskOptionId }, true);
                            if (r && r.length > 0) {
                                $scope.aux.MaskOption = r[0];
                            }
                        }

                    }, function (error) {
                        errors.showError(error);
                        $state.go('metadata-find');
                    });

                }, function (error) {
                    errors.showError(error);
                    $state.go('metadata-find');
                });

                $scope.createJson = function (attribute) {

                    if (attribute.values && attribute.values.length > 0) {
                        var jsonArr = [];
                        for (var i = 0; attribute.values.length > i; i++) {
                            if ($scope.aux.typeData && $scope.aux.typeData.type === 'comboKV') {
                                jsonArr.push({
                                    value: attribute.values[i].value,
                                    description: attribute.values[i].description,
                                    active: attribute.values[i].active === undefined ? true : attribute.values[i].active
                                });
                            } else {
                                jsonArr.push({
                                    value: attribute.values[i].value
                                });
                            }
                        }

                        attribute.value = JSON.stringify(jsonArr);
                    }
                };

                $scope.selectMk = function () {
                    if ($scope.aux.MaskOption) {
                        $scope.metadata.maskOptionId = $scope.aux.MaskOption.id;
                    } else {
                        $scope.metadata.maskOptionId = undefined;
                    }
                };

                $scope.selectType = function () {
                    $scope.aux.MaskOption = undefined;
                    $scope.selectMk();

                    $scope.metadata.attributes = [];

                    if ($scope.aux.typeData) {
                        $scope.metadata.typeDataId = $scope.aux.typeData.id;

                        $scope.aux.typeData.typeDataAttributes.forEach(function (attribute) {

                            $scope.metadata.attributes.push(
                                {
                                    typeDataAttributeId: attribute.id,
                                    typeDataAttributeName: attribute.name,
                                    value: '',
                                    type: attribute.type,
                                    values: []
                                });
                        });
                    } else {
                        $scope.metadata.typeDataId = '';
                    }
                };

                $scope.validateAtribute = function () {
                    if ($scope.metadata.attributes.length > 0) {
                        var minLength = 0;
                        var maxLength = 0;

                        for (var i = 0; $scope.metadata.attributes.length > i; i++) {
                            if ($scope.metadata.attributes[i].type === 'optionsValues') {
                                if ($scope.metadata.attributes[i].values.length <= 0) {
                                    return false;
                                }
                                $scope.createJson($scope.metadata.attributes[i]);
                            }
                            if ($scope.metadata.typeDataName === 'String') {
                                if ($scope.metadata.attributes[i].type === 'maxlength') {
                                    maxLength = parseInt($scope.metadata.attributes[i].value);
                                }
                                if ($scope.metadata.attributes[i].type === 'minlength') {
                                    minLength = parseInt($scope.metadata.attributes[i].value);
                                }

                            }
                        }
                        if ((((maxLength < minLength) && maxLength !== 0 && minLength !== 0) || maxLength < 0 || minLength < 0) && !$scope.metadata.mask) {
                            return false;
                        }

                    }
                    return true;
                };

                $scope.save = function () {
                    if (!$scope.metadataForm.$valid || !$scope.validateAtribute()) {
                        errors.showError('VerifyFormData');
                        $scope.metadataForm.$setSubmitted();
                        return false;
                    }

                    return adminMetadataService.modify($scope.metadata).then(function (metadata) {
                        $state.go('metadata-find', { systemName: metadata.systemName });
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.cancel = function () {
                    $state.go('metadata-find');
                };

                $scope.existValue = function (attribute, value) {
                    if (attribute.values && attribute.values.length > 0) {
                        for (var i = 0; attribute.values.length > i; i++) {
                            if (attribute.values[i].value === value) {
                                return true;
                            }
                        }
                    }

                    return false;
                };

                $scope.addOption = function ($event, attribute) {
                    // para que no ejecute el post al apretar enter
                    $event.stopPropagation();

                    $scope.aux.selected = {};
                    if (attribute.option && attribute.option !== '' && !$scope.existValue(attribute, attribute.option)) {

                        // solo valiudo descripcion si es un combo key value
                        if ((!$scope.aux.typeData || $scope.aux.typeData.type !== 'comboKV') || $scope.aux.typeData && $scope.aux.typeData.type === 'comboKV' && attribute.optionDescription && attribute.optionDescription !== '') {

                            attribute.values.push({ value: attribute.option, description: attribute.optionDescription, isNew: true });
                            attribute.option = '';
                            attribute.optionDescription = '';

                            var element = $window.document.getElementById("inputOptionValue");
                            if (element) {
                                element.focus();
                            }
                        }
                    }
                };

                $scope.order = function orderAsc(attribute, asc) {
                    if (!$scope.aux.typeData !== null && $scope.aux.typeData.type === 'comboKV') {
                        attribute.values = $filter('orderBy')(attribute.values, 'description', asc);
                    } else {
                        attribute.values = $filter('orderBy')(attribute.values, 'value', asc);
                    }
                };

                $scope.removeValue = function (attribute, item) {
                    if (!attribute || !attribute.values) {
                        return;
                    }

                    var indexOf = -1;
                    for (var i = 0; i < attribute.values.length; i++) {
                        if (attribute.values[i] === item) {
                            indexOf = i;
                            break;
                        }
                    }

                    if (indexOf >= 0) {
                        attribute.values.splice(indexOf, 1);
                    }
                };
            }
        ]);
})();